import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/member-cell.scss';

Component('tr-grid-member-cell', {
  mixins: [baseMixin],

  properties: {
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.selectedList = this.querySelector('.selector-field-result .selected-list');

    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-selector-field:change': this.handleChange.bind(this),
      'tr-selector-field-list:opened': () => { this.editing = true; },
      'tr-selector-field-list:closed': () => { this.editing = false; },
      'tr-combo-select-field:change': this.handleMultiSelectorChange.bind(this),
      'tr-combo-select-field:menuClosed': () => { this.editing = false; },
    });
  },

  preventClickEvent({ target }) {
    return this.editable
      && closest(target, '.selector-field-result', this);
  },

  handleClick({ target }) {
    if (closest(target, '.selector-field-result', this)) {
      this.beginEditing();
    }
  },

  async beginEditing() {
    if (!this.editable || this.editing) return;

    await this.prepareEditor();
    this.destroyOverflowTooltip();
    if (!this.editor) return;

    if (this.multiple) {
      this.editing = true;
      this.editor.focus();
    }

    this.editor.toggleList(true);
  },

  prepareEditor() {
    return new Promise(async (resolve) => {
      if (this.editorInitialized) {
        resolve();
      } else {
        this.editor = await this.editorLoader.editor;
        this.editorInitialized = true;
        if (!this.editor) {
          resolve();
          return;
        }

        const selected = this.multiple
          ? (this.value || '').split(',') : [this.value || 'blank'];
        selected.forEach((val) => {
          const selectedOption = this.editor
            .querySelector(`select option[value="${val}"]`);
          if (selectedOption) selectedOption.selected = true;
        });

        this.listenTo(this.editor, 'tao:ready', resolve, { once: true });

        if (this.multiple) {
          this.appendChild(this.editor);
        } else {
          this.replaceChild(this.editor, this.firstElementChild);
        }
      }
    });
  },

  getTextContentElement() {
    return this.multiple ? this.selectedList
      : this.querySelector('.selector-field-result');
  },

  handleChange(event) {
    const value = event.detail === 'blank' ? '' : event.detail;
    if (!value && !this.value) return;

    this.value = value;
    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },

  handleMultiSelectorChange(event) {
    const value = event.detail || [];
    this.value = value.join(',');

    this.selectedList.innerHTML = this.editor.list.options
      .filter(option => value.indexOf(option.value) !== -1)
      .map(option => `
        <div class="selected-text">
          <img src="${option.data.avatar}" class="avatar" alt="${option.text}">
          <span class="text">${option.text}</span>
        </div>
      `).join('\n');

    this.namespacedTrigger('cellValueChange', {
      detail: { value },
      bubbles: true,
    });
  },
});
